import React from 'react';
import UserForm from './UserForm';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';

// Images
import banner from './images/banner.jpg';
import brand0 from './images/brands_0.jpeg';
import brand1 from './images/brands_1.jpeg';
import brand2 from './images/brands_2.jpeg';
import brand3 from './images/brands_3.jpeg';
import brand4 from './images/brands_4.jpeg';
import brand5 from './images/brands_5.jpeg';
import brand6 from './images/brands_6.jpeg';
import brand7 from './images/brands_7.jpeg';
import brand8 from './images/brands_8.jpeg';


export default class Home extends React.Component {
  render() {
    return (
      <div className="body">
        <div className="banner">
          <div className="overlay">
            <Image src={banner} className="image" />
            <div className="gradient"></div>
          </div>
          <div>
            <Container className="relative">
              <Row className="justify-content-center">
                <Col md={9} className="text-center">
                  <h1>Make Money Online $300/Month*</h1>
                  <Row className="justify-content-center">
                    <Col md={9} className="text-center">
                      <p>Take surveys online to earn cash &amp; gift cards with Singapore's highest paid surveys. It's fast, easy and free!&nbsp;</p>
                      <p><strong><em>Limited places available.</em></strong></p>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col md={4}>
                  <UserForm />
                </Col>
              </Row>
              <Row className="justify-content-center mt-4">
                <Col md={12} className="text-center">
                  <p className="small medium-small text-extra-dark">*Based on <a className="text-underline" href="">possible earnings</a>. These differ due to panelist demographics and survey companies selected, results vary per person.</p>
                  <p className="small medium-small text-extra-dark">By submitting this form, you agree to our <a href="">Terms &amp; Conditions</a> and <a href="">Privacy Policy</a>.</p>
                </Col>
              </Row>
            </Container>

          </div>
        </div>
        <Container>
          <Row className="justify-content-center">
            <Col md={4} className="text-center">
              <h4 className="big-number gradient-text no-hover active">1</h4>
              <h3 className="mt-2"><strong>Sign</strong>&nbsp;up</h3>
              <p className="px-1">Register for&nbsp;Singapore's best paying surveys using our simple form. It's fast, easy and 100% free!</p>
            </Col>
            <Col md={4} className="text-center">
              <h4 className="big-number gradient-text no-hover active">2</h4>
              <h3 className="mt-2">Take&nbsp;<strong>Surveys</strong></h3>
              <p className="px-1">Answer surveys online. Take more surveys, make more money!</p>
            </Col>
            <Col md={4} className="text-center">
              <h4 className="big-number gradient-text no-hover active">3</h4>
              <h3 className="mt-2">Get&nbsp;<strong>Paid</strong></h3>
              <p className="px-1">Get paid for your opinion. Cash will be paid through&nbsp;<strong>PayPal</strong>, or cheque. Gift cards will be emailed to you.</p>
            </Col>
          </Row>
          <Row className="justify-content-center mt-5 pt-5">
            <Col md={8} className="text-center">
              <h3 className="fancytext">
                Top&nbsp;
                <strong className="">
                  <span className="">B</span>
                  <span className="">r</span>
                  <span className="">a</span>
                  <span className="faded">n</span>
                  <span className="faded">d</span>
                  <span className="faded">s</span>
                </strong>
                &nbsp;need your opinions
              </h3>
              <p>Top brands need your opinions on their products and services. Earn rewards by sharing your thoughts in online surveys. Earn cash, gift cards or free products. Earn rewards for every survey you complete.</p>
            </Col>
          </Row>
          <div className="row justify-content-center mt-4 mb-5">
            <div className="col-md-7">
              <div className="row">
                <div className="col-md-4 border-right">
                  <img className="img-fluid d-block mx-auto" src={brand0} />
                </div>
                <div className="col-md-4 border-right">
                  <img className="img-fluid d-block mx-auto" src={brand1} />
                </div>
                <div className="col-md-4">
                  <img className="img-fluid d-block mx-auto" src={brand2} />
                </div>
              </div>
              <div className="row border-top border-bottom">
                <div className="col-md-4 border-right">
                  <img className="img-fluid d-block mx-auto" src={brand3} />
                </div>
                <div className="col-md-4 border-right">
                  <img className="img-fluid d-block mx-auto" src={brand4} />
                </div>
                <div className="col-md-4">
                  <img className="img-fluid d-block mx-auto" src={brand5} />
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 border-right">
                  <img className="img-fluid d-block mx-auto" src={brand6} />
                </div>
                <div className="col-md-4 border-right">
                  <img className="img-fluid d-block mx-auto" src={brand7} />
                </div>
                <div className="col-md-4">
                  <img className="img-fluid d-block mx-auto" src={brand8} />
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center pb-xl-5">
            <div className="col-md-4">
              <a className="btn btn-primary btn-block btn-shadow mb-5" href="">Join Free</a>
            </div>
          </div>
        </Container>
        <div className="footer text-center">
          <div className="container">
            <div className="row">
            </div>
            <div className="row">
              <div className="col-12 copyright">
                <ul>
                  <li><a href="">Terms &amp; Conditions</a></li>
                  <li><a href="">Privacy Policy</a></li>
                </ul>
                <p>© 2021 Kensto</p>
                <p>*Based on <a className="text-underline" href="">possible earnings</a>. These differ due to panelist demographics and survey companies selected, results vary per person.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}